import { useTranslation } from "react-i18next";
import { HiMagnifyingGlass } from "react-icons/hi2";

const StartSearch = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-grow flex-col items-center justify-center px-4" data-testid={"search-start"}>
      <div className="flex size-14 items-center justify-center rounded-full bg-brand-primary-subtle">
        <HiMagnifyingGlass className="size-7 text-fg-brand-primary" />
      </div>
      <div className="mt-3 max-w-md text-center">
        <h1 className="text-xl font-semibold text-primary">{t("search.start.title")}</h1>
        <p className="mt-2 text-sm text-tertiary">{t("search.start.text")}</p>
      </div>
    </div>
  );
};

export default StartSearch;
